// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles for all buttons and inputs */
.root__iOEDVYyZv3KvAVUHmuvQ {
  outline-color: transparent;
  position: relative;
  box-sizing: border-box;
  font-family: inherit;
  color: var(--cp-text);
}
.root__iOEDVYyZv3KvAVUHmuvQ:focus-visible {
  outline: 1px auto var(--cp-black);
}
.root__iOEDVYyZv3KvAVUHmuvQ:hover,
.root__iOEDVYyZv3KvAVUHmuvQ:active {
  --cp-text: var(--cp-textHover);
}
.root__iOEDVYyZv3KvAVUHmuvQ:disabled {
  cursor: not-allowed;
  --cp-text: var(--cp-textDisabled);
  --cp-border: var(--cp-bgDisabled);
  background-color: var(--cp-bgDisabled);
}

/* things that might conflict with custom buttons */
.standard__zj0TbNwd1QXrGvAbo9DT {
  font-size: var(--cp-fontSizeMd);
  height: 32px;
  border: 1px solid var(--cp-border);
  border-radius: var(--cp-inputRadius, 2px);
}
.standard__zj0TbNwd1QXrGvAbo9DT:hover {
  --cp-border: var(--cp-borderHover);
  --cp-text: var(--cp-textHover);
}
.standard__zj0TbNwd1QXrGvAbo9DT:active {
  --cp-border: var(--cp-borderActive, var(--cp-borderHover));
  --cp-text: var(--cp-textHover);
}
.standard__zj0TbNwd1QXrGvAbo9DT:disabled {
  --cp-border: var(--cp-borderDisabled);
  --cp-text: var(--cp-textDisabled);
  background-color: var(--cp-bgDisabled);
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/inputCommon.module.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,iCAAiC;AACnC;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA,mDAAmD;AACnD;EACE,+BAA+B;EAC/B,YAAY;EACZ,kCAAkC;EAClC,yCAAyC;AAC3C;AACA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,0DAA0D;EAC1D,8BAA8B;AAChC;AACA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,sCAAsC;AACxC","sourcesContent":["/* styles for all buttons and inputs */\n.root {\n  outline-color: transparent;\n  position: relative;\n  box-sizing: border-box;\n  font-family: inherit;\n  color: var(--cp-text);\n}\n.root:focus-visible {\n  outline: 1px auto var(--cp-black);\n}\n.root:hover,\n.root:active {\n  --cp-text: var(--cp-textHover);\n}\n.root:disabled {\n  cursor: not-allowed;\n  --cp-text: var(--cp-textDisabled);\n  --cp-border: var(--cp-bgDisabled);\n  background-color: var(--cp-bgDisabled);\n}\n\n/* things that might conflict with custom buttons */\n.standard {\n  font-size: var(--cp-fontSizeMd);\n  height: 32px;\n  border: 1px solid var(--cp-border);\n  border-radius: var(--cp-inputRadius, 2px);\n}\n.standard:hover {\n  --cp-border: var(--cp-borderHover);\n  --cp-text: var(--cp-textHover);\n}\n.standard:active {\n  --cp-border: var(--cp-borderActive, var(--cp-borderHover));\n  --cp-text: var(--cp-textHover);\n}\n.standard:disabled {\n  --cp-border: var(--cp-borderDisabled);\n  --cp-text: var(--cp-textDisabled);\n  background-color: var(--cp-bgDisabled);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__iOEDVYyZv3KvAVUHmuvQ`,
	"standard": `standard__zj0TbNwd1QXrGvAbo9DT`
};
export default ___CSS_LOADER_EXPORT___;
